/**
 * Created by toomasp on 11.08.2015.
 */
"use strict"
export let errorMsg:any[] = ["$compile", "translator", ($compile, translator) => {
    let HTML = '<span class="msg-error" data-ng-show="msg"><i class="icon-attention"></i> {{msg}}</span>';

    function findFirstError(errors) {
        let errorName;
        if (!errors) {
            return '';
        }
        for (errorName in errors) {
            if (errors[errorName]) {
                return errorName;
            }
        }
        return '';
    }

    function getErrorParam(element, error) {
        let labelName;
        switch (error) {
            case "required":
                labelName = element.attr('data-label');
                if (!labelName) {
                    return [element.attr('data-ng-model')];
                }
                return [labelName];
            default:
                return [];
        }
    }

    function getContainer(element, target) {
        if (!target) {
            return element.parents('div:first');
        }
        if (target.indexOf('#') === 0) {
            return $(target);
        }

        return element.parents(target + ':first');
    }


    class ErrorMsgDirective {
        restrict = 'A';
        require = 'ngModel';

        link(scope, element, attrs, ngModelCtrl) {
            element = $(element);

            // Add message element to HTML
            let directiveScope = scope.$new();
            let linkFn = $compile(angular.element(HTML));
            let msgElement = linkFn(directiveScope);

            let container = getContainer(element, attrs.errorMsgTarget);
            container.append(msgElement);

            let errorsChanged = () => {
                let enabled = !attrs.errorMsg || scope.$eval(attrs.errorMsg);

                if (ngModelCtrl.$valid || !enabled) {
                    directiveScope.msg = '';
                } else {
                    let error = findFirstError(ngModelCtrl.$error);
                    if (!error) {
                        directiveScope.msg = '';
                        return;
                    }


                    let label = element.attr('data-label-' + error);
                    if (!label) {
                        label = 'error.' + error;
                    }

                    directiveScope.msg = translator.translateParam(label, getErrorParam(element, error));
                }
            }

            let trlUnbinder = translator.bind(translator.Event.LANGUAGE_CHANGED, errorsChanged);
            scope.$on('destroy', () => trlUnbinder.unbind());

            scope.$watchCollection(() => ngModelCtrl.$error, errorsChanged);
            scope.$watch(()=>!attrs.errorMsg || scope.$eval(attrs.errorMsg), errorsChanged);
        }
    }

    return new ErrorMsgDirective();
}];


// WEBPACK FOOTER //
// ./src/main/ui/core/directives/decorator/error-message.directive.ts